import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SidenavComponent } from '../components/sidenav/sidenav.component';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  private sidenavComponent?: SidenavComponent;
  private collapsedSidenavSubject = new BehaviorSubject<boolean>(false);
  public collapsedSidenav$: Observable<boolean> =
    this.collapsedSidenavSubject.asObservable();

  constructor() {
    const savedState = localStorage.getItem('@broadfactorgov:sidenav');

    if (savedState) {
      this.collapsedSidenavSubject.next(JSON.parse(savedState));
    }
  }

  setSidenav(sidenav: SidenavComponent): void {
    this.sidenavComponent = sidenav;
    const isCollapsed = this.collapsedSidenavSubject.getValue();

    if (isCollapsed && sidenav) {
      sidenav.isCollapsed = true;
    }
  }

  toggle(): void {
    this.sidenavComponent?.toggle();
  }

  open(): void {
    this.sidenavComponent?.open();
  }

  close(): void {
    this.sidenavComponent?.close();
  }

  toggleCollapse(): void {
    this.sidenavComponent?.toggleCollapse();
    const newState = !this.collapsedSidenavSubject.getValue();
    this.collapsedSidenavSubject.next(newState);
    localStorage.setItem('@broadfactorgov:sidenav', JSON.stringify(newState));
  }

  setCollapsed(collapsed: boolean): void {
    if (
      this.sidenavComponent &&
      this.sidenavComponent.isCollapsed !== collapsed
    ) {
      this.toggleCollapse();
    }
  }

  isCollapsed(): boolean {
    return this.collapsedSidenavSubject.getValue();
  }

  isMobile(): boolean {
    return this.sidenavComponent?.isMobile ?? false;
  }
}
